import { render, staticRenderFns } from "./PricingMobileMonthly.vue?vue&type=template&id=566b0229&scoped=true&"
import script from "./PricingMobileMonthly.vue?vue&type=script&lang=js&"
export * from "./PricingMobileMonthly.vue?vue&type=script&lang=js&"
import style0 from "./PricingMobileMonthly.vue?vue&type=style&index=0&id=566b0229&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b0229",
  null
  
)

export default component.exports